import React from "react";
import Box from "@mui/material/Box";
import { CircularProgress } from "@mui/material";
import LinkWithArrow from "src/components/common/Buttons/LinkWithArrow";

interface LoaderBlockProps {
  isLoading?: boolean;
  isHasNextPage?: boolean;
  onNextPage?: () => void;
}

const LoadMoreBlock: React.FC<LoaderBlockProps> = ({
  isLoading,
  isHasNextPage,
  onNextPage,
}) => {
  if (!isLoading && !isHasNextPage) return null;

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      paddingTop={2}
      paddingBottom={{ xs: 13, md: 3 }}
    >
      {isLoading && <CircularProgress size={25} sx={{ mr: 2 }} />}
      {isHasNextPage && onNextPage && (
        <LinkWithArrow
          downArrow
          onClick={() => onNextPage()}
          title="Больше предложений"
        />
      )}
    </Box>
  );
};

export default LoadMoreBlock;
